import { EntityItem } from "services/api/notifications/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const ENTITY_COLUMNS: Column[] = [
  {
    title: "Naziv",
    field: "displayName",
    type: ColumnTypes.string,
    sortable: true,
  },
  {
    title: "Datum",
    type: ColumnTypes.custom,
    render: (row: EntityItem) =>
      row.relevantDate ? (
        <span className="text-xs text-slate-500">
          {new Date(row.relevantDate).toLocaleDateString("hr-HR")}
        </span>
      ) : row.hasMissingDate ? (
        <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs bg-orange-50 text-orange-600 border border-orange-200">
          Nema datuma
        </span>
      ) : null,
  },
];
